var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0069 27.1472C28.1202 27.1481 27.2702 27.501 26.6439 28.1282C26.0173 28.7555 25.6656 29.6059 25.666 30.4923C25.6662 31.3789 26.0185 32.2289 26.6455 32.8559C27.2723 33.4827 28.1225 33.8349 29.0089 33.8354C29.8955 33.8356 30.7457 33.4838 31.3729 32.8575C32.0002 32.2309 32.353 31.3809 32.354 30.4945C32.3531 29.607 32.0002 28.7561 31.3727 28.1287C30.745 27.501 29.8941 27.1481 29.0069 27.1472V27.1472Z",
    fill: "#04B7B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 27.1472C13.7809 27.1472 12.9305 27.4994 12.3032 28.1265C11.6762 28.7533 11.3237 29.6035 11.3235 30.4903C11.3233 31.3769 11.675 32.2273 12.3018 32.8548C12.9284 33.4821 13.7786 33.8347 14.6652 33.8354C15.5521 33.8358 16.4027 33.4843 17.0302 32.8577C17.6576 32.2314 18.0105 31.3811 18.0114 30.4946C18.0105 29.6075 17.6581 28.7573 17.0313 28.1298C16.4045 27.5024 15.5543 27.149 14.6675 27.1473V27.1472Z",
    fill: "#04B7B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.504 5H5V6.92011H8.9904L12.3183 20.8144V20.8142C11.7917 21.4113 11.5167 22.189 11.5506 22.9843C11.5845 23.7796 11.925 24.5309 12.5006 25.0809C13.0763 25.6307 13.8423 25.9365 14.6383 25.9343H32.1423V24.0142H14.6349C14.2175 24.0142 13.832 23.7916 13.6233 23.4302C13.4146 23.0689 13.4146 22.6238 13.6233 22.2623C13.832 21.901 14.2175 21.6782 14.6349 21.6782H31.9532L34.9259 9.63646H11.6139L10.504 5Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDefault);
export default __webpack_public_path__ + "static/media/Cart_default.dde9387b2d50c12b59a35fae77ac276e.svg";
export { ForwardRef as ReactComponent };